module.exports = __webpack_public_path__ + "assets/img/W1-5-F.cb1ce1b4.png";